export function wait(millis) {
    return new Promise(function (resolve) { return setTimeout(resolve, millis); });
}
